<app-loading-spinner [backdropEnabled]="false" [blockScrolling]="false" [positionGloballyCenter]="true"
    [displayOverlay]="loadingInProgress(companiesLoadState | async, assetLoadState | async, recentPathLoadState | async)">

    <!--   *ngIf is not working properly for unknown reasons that are too much to debug, so thats why settled for [style.display] --> 
    <app-progress-spinner 
        class="desktop-main-app-spinner"
        [style.display]="loading ? 'auto' : 'none'"
    >
    </app-progress-spinner>
</app-loading-spinner>
<app-desktop-sidebar >
    <ng-container>
        <app-map-header class="map-header" (filterClick)="handleOpenFilterDialog.emit()"></app-map-header>
        <app-asset-list 
            fxFlex 
            class="content-pane"
            (hoverOver)="locationFacade.setHover($event)" 
            (hoverOut)="locationFacade.clearHover()"
        ></app-asset-list>
    </ng-container>
</app-desktop-sidebar>
